import type { BlockImportPreview, BlockImportRow, BlockImportSummary } from "../../api/types";

// Mirrors the server cap so an oversized file fails before it is uploaded.
export const IMPORT_MAX_BYTES = 1024 * 1024;

export const IMPORT_COLUMNS = [
  "Project",
  "Block",
  "Sub-block",
  "Pillar",
  "Team",
  "Executive Owner Email",
  "Assignee Email",
  "Contributor Emails",
  "Impact",
  "Significance",
  "Size",
  "Due Date",
  "Progress",
  "Acceptance Criteria"
];

// One row per level, plus a quoted multi-line acceptance criteria cell and a
// contributor list, so the template demonstrates every format rule.
export const IMPORT_TEMPLATE_CSV = [
  IMPORT_COLUMNS.join(","),
  'Launch Connect,,,Product,Platform,ada.lovelace@queen.one,grace.hopper@queen.one,,4,3,,2026-12-31,0,"Connect is live for every client\nOnboarding takes under two days"',
  "Launch Connect,Text channel,,,Platform,,grace.hopper@queen.one,,,,40,,25,",
  "Launch Connect,Text channel,RCS support,,Platform,,margaret.hamilton@queen.one,ada.lovelace@queen.one;alan.turing@queen.one,,,15,2026-10-15,,"
].join("\n") + "\n";

export const IMPORT_TEMPLATE_HREF = `data:text/csv;charset=utf-8,${encodeURIComponent(IMPORT_TEMPLATE_CSV)}`;

// importRowPath joins a row's filled name columns, e.g. "Connect › Text › RCS".
export function importRowPath(row: Pick<BlockImportRow, "project" | "block" | "sub_block">): string {
  return [row.project, row.block, row.sub_block].filter((name) => name !== "").join(" › ");
}

export function importErrorCount(preview: BlockImportPreview): number {
  return preview.rows.reduce((sum, row) => sum + row.errors.length, preview.errors.length);
}

export function importSummaryText(summary: BlockImportSummary): string {
  return [
    plural(summary.projects, "project"),
    plural(summary.blocks, "block"),
    plural(summary.sub_blocks, "sub-block")
  ].join(" · ");
}

export function importNewUsersText(emails: string[]): string {
  const created =
    emails.length === 1 ? "1 new user will be created as an IC" : `${emails.length} new users will be created as ICs`;
  return `${created}: ${emails.join(", ")}.`;
}

function plural(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}
